import angular from 'angular';
import constants from 'app/constants';
import {
  bcpDataService,
  loaderService,
  ssDialogService,
  userService,
} from 'app/services';
import performThreatAssessmentDialog from './dialog.performThreatAssessmentDialog';
import assessmentThreats from './assessmentThreats';
import controller from './enterprise-threat-assessment.controller';
import directive from './enterprise-threat-assessment.directive';


export default angular.module('app.components.advisory.bcp.enterpriseThreatAssessment', [
  bcpDataService,
  constants,
  loaderService,
  performThreatAssessmentDialog,
  ssDialogService,
  userService,
  assessmentThreats,
])
  .directive('bcpEnterpriseThreatAssessment', directive)
  .controller('EnterpriseThreatAssessmentController', controller)
  .name;

console.log('app.components.advisory.bcp.enterpriseThreatAssessment created');
